import { render, staticRenderFns } from "./BulkSuspendDynamicListDialog.vue?vue&type=template&id=222a39a9"
import script from "./BulkSuspendDynamicListDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkSuspendDynamicListDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports